import { useTranslation } from 'react-i18next';

const useLocalize = () => {
  const { t } = useTranslation();

  const localize = (key, options) =>
    t(key, options)
      .replace(/(?: )([:!?-])/giu, '\u00A0$1')
      .replace(/_/giu, '\u00A0')
      .replace(/\[(&#\d+)\]/giu, '$1;');

  return { localize };
};

export default useLocalize;
